import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconDashboard } from "@tabler/icons-react";
import { DashboardClientesDef } from "./DashboardClientesDef";

export const DashboardClientesIcon = IconDashboard;
export const DashboardClientesHelpText = '* Dashboard.';

export class DashboardClientes extends Entity<DashboardClientesDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new DashboardClientesDef(), parentKeys);
        this.Form = import('./DashboardClientesForm').then((module) => module.DashboardClientesForm);
        this.Title = "Dashboard Clientes";
        this.HelpText = DashboardClientesHelpText;
        this.Icon = DashboardClientesIcon;
    }
}